import { render, staticRenderFns } from "./PasswordResetFinal.vue?vue&type=template&id=ba27e922&"
import script from "./PasswordResetFinal.vue?vue&type=script&lang=js&"
export * from "./PasswordResetFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports